// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.categories {
    text-align: center;
    min-width: 200px;
}

.categoryTitle {
    font-weight: bold;
    min-width: 200px;
}

.categoryButton {
    margin-top: 0.5em;
    color: rgb(8, 70, 19);
    border: none;
    font-weight: bold;
    font-size: 1.1em;
    min-width: 133px;
    padding: 0.2em;
    border-radius: .5em;
    background-color: rgb(255, 255, 255);
}`, "",{"version":3,"sources":["webpack://./src/components/categories.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,oCAAoC;AACxC","sourcesContent":[".categories {\n    text-align: center;\n    min-width: 200px;\n}\n\n.categoryTitle {\n    font-weight: bold;\n    min-width: 200px;\n}\n\n.categoryButton {\n    margin-top: 0.5em;\n    color: rgb(8, 70, 19);\n    border: none;\n    font-weight: bold;\n    font-size: 1.1em;\n    min-width: 133px;\n    padding: 0.2em;\n    border-radius: .5em;\n    background-color: rgb(255, 255, 255);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
